<template>
    <div>
        <common-button type="link" size="huge" icon="share" :label="buttonlabel" @click="openShareModal()"></common-button>

        <common-modal v-if="isShareModalOpen" @close="closeShareModal">
            <div class="social-share">
                <div class="social-share--input">
                    <text-input id="url" type="text" :isDisabled="true" :prefillVal="sharing.url"></text-input>
                    <common-icon name="copy" size="huge" @click="copyUrl()"></common-icon>
                </div>
                <div class="social-share--buttons">
                    <ShareNetwork
                        v-for="network in networks"
                        :key="network.network"
                        class="social-share--buttons--item"
                        :network="network.network"
                        :style="{ backgroundColor: network.color }"
                        :url="sharing.url"
                        :title="sharing.title"
                        :description="sharing.description"
                        :quote="sharing.quote"
                        :hashtags="sharing.hashtags"
                        :twitterUser="sharing.twitterUser"
                    >
                        <common-icon :name="network.icon" size="small"></common-icon>
                    </ShareNetwork>
                </div>
            </div>
        </common-modal>
    </div>
</template>

<script>
    import TextInput from 'components/form-inputs/TextInput'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'

    export default {
        mixins: [WindowResizeMixin],
        components: { TextInput },
        props: {
            title: { type: String, default: '' },
            description: { type: String, default: '' },
            buttonlabel: { type: String, default: '' },
        },

        data: () => ({
            sharing: {},
            networks: [
                { network: 'facebook', icon: 'facebook' },
                { network: 'linkedin', icon: 'linkedin' },
                { network: 'twitter', icon: 'twitter' },
                { network: 'viber', icon: 'viber' },
                { network: 'whatsapp', icon: 'whatsapp' },
                { network: 'email', icon: 'email' },
            ],
            isShareModalOpen: false,
        }),

        methods: {
            copyUrl() {
                const urlDiv = document.getElementById('url')
                const input = urlDiv.querySelector('input')
                if (input) {
                    input.select()
                    input.setSelectionRange(0, 99999)
                    const ulr = this.sharing.url.replace(/\/#\//g, '/%23/')
                    navigator.clipboard.writeText(ulr)
                    this.$toast.success(this.$t('common.microcopy.copied'))
                }
            },

            openShareModal() {
                this.isShareModalOpen = true
            },

            closeShareModal() {
                this.isShareModalOpen = false
            },
        },

        watch: {
            $route() {
                this.sharing.url = window.location.href
            },
        },

        mounted() {
            this.sharing = {
                url: window.location.href,
                title: this.title,
                description: this.description,
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .social-share {
        display: flex;
        flex-wrap: wrap;
        max-width: 100%;

        &--input {
            margin-top: 10px;
            @include breakpoint(smartphone-large) {
                margin-top: 20px;
            }
            width: 100%;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .form-input-text {
                width: 100%;
            }

            .icon {
                cursor: pointer;
                position: absolute;
                right: 10px;
                backdrop-filter: blur(50px);
                min-width: 40px;
            }
        }

        &--buttons {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 10px;

            @include breakpoint(smartphone-large) {
                justify-content: center;
            }

            &--item {
                @include breakpoint(smartphone-large) {
                    width: 30%;
                    text-align: center;
                    max-width: 200px;
                    margin: 10px;
                }
            }
        }

        .share-network-facebook,
        .share-network-linkedin,
        .share-network-twitter,
        .share-network-viber,
        .share-network-whatsapp,
        .share-network-email {
            color: white;

            padding: 10px;
            border-radius: 10px;

            .icon {
                margin-right: 5px;
                margin-left: 5px;
            }
        }

        .share-network-facebook {
            background-color: $color-blue--facebook;
        }

        .share-network-linkedin {
            background-color: $color-network--linkedin;
        }

        .share-network-twitter {
            background-color: $color-network--twitter;
        }

        .share-network-viber {
            background-color: $color-network--viber;
        }

        .share-network-whatsapp {
            background-color: $color-network--whatsapp;
        }

        .share-network-email {
            background-color: $color-network--email;
        }
    }
</style>
